import React from 'react';
import { NoPhoneNumbersFound } from '../../../../../../../../../../shared/svg';

const NoPhoneNumberFound: React.FC = () => (
  <div className="d-flex flex-column align-items-center justify-content-center h-100 no-phone-number-found">
    <NoPhoneNumbersFound />
    <p className="text">No phone numbers available for the selected filters.</p>
    <p className="text-2">Try adjusting your search criteria or explore other regions/types.</p>
  </div>
);

export default NoPhoneNumberFound;